<script setup lang="ts">
import { ArrowRight, BookOpen, ShieldCheck, Sparkles } from '@lucide/vue'
import type { PresentedRelease } from '~~/shared/schemas/changelog'

defineProps<{
  releases: PresentedRelease[]
  saving: boolean
  error: string
  reason: 'normal' | 'forced-critical'
}>()
const emit = defineEmits<{ close: []; acknowledge: [] }>()
</script>

<template>
  <UiModal
    :open="true"
    class="changelog-dialog"
    :class="{ 'is-multi-release': releases.length > 1 }"
    size="lg"
    @close="emit('close')"
  >
    <template #header-leading
      ><ShieldCheck
        v-if="reason === 'forced-critical'"
        :size="24" /><Sparkles
        v-else
        :size="24"
    /></template>
    <template #header-title>{{
      reason === 'forced-critical' ? 'Mises à jour critiques' : 'Quoi de neuf dans Morning ?'
    }}</template>
    <template #header-meta
      ><p>{{ releases.length }} versions à découvrir</p></template
    >

    <div
      class="changelog-dialog-scroll"
      :class="{ 'is-multi-release': releases.length > 1 }"
    >
      <div
        v-for="(release, index) in releases"
        :key="release.version"
        class="changelog-dialog-release"
      >
        <div
          v-if="releases.length > 1"
          class="changelog-dialog-release-marker"
          aria-hidden="true"
        >
          <span>{{ String(index + 1).padStart(2, '0') }}</span>
        </div>
        <div class="changelog-dialog-release-content">
          <span
            v-if="releases.length > 1"
            class="changelog-dialog-release-position"
          >
            {{
              index === 0
                ? 'La plus récente'
                : `Version précédente · ${index + 1}/${releases.length}`
            }}
          </span>
          <ChangelogReleaseCard :release="release" />
        </div>
      </div>
    </div>
    <template #footer
      ><footer class="changelog-dialog-footer">
        <p
          v-if="error"
          role="alert"
        >
          {{ error }}
        </p>
        <NuxtLink
          to="/changelog"
          @click="emit('close')"
          ><BookOpen
            :size="17"
            aria-hidden="true"
          />
          Tout l’historique</NuxtLink
        >
        <UiButton
          class="changelog-acknowledge"
          type="button"
          :disabled="saving"
          @click="emit('acknowledge')"
        >
          {{ saving ? 'Enregistrement…' : 'J’ai pris connaissance des nouveautés' }}
          <ArrowRight
            v-if="!saving"
            :size="17"
            aria-hidden="true"
          />
        </UiButton></footer
    ></template>
  </UiModal>
</template>

<style lang="scss" src="~/assets/scss/sfc/components/changelog/ChangelogReleaseModal.scss"></style>
